module.exports = __webpack_public_path__ + "assets/485fa6afe777b5917d0c43202fd711ae.mp3";